<template> 
  <div class="mt-5">
    <p :style="{ fontSize: labelSize }">{{ label }}</p>
    <p :style="{ fontSize: valueSize }" class="text-primary font-semibold">
      {{ value }}
    </p>
  </div>
</template>
<script>
export default {
  name: "MyComponent",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    labelSize: {
      type: String,
      default: "16px",
    },
    valueSize: {
      type: String,
      default: "20px",
    },
  },
};
</script>
